// extracted by mini-css-extract-plugin
export default {"btn-actions":"issue-participant-form_btn-actions__7-ldZ","add-btn":"issue-participant-form_add-btn__N5Jjs","content-buffer":"issue-participant-form_content-buffer__MYmb8"};